import { Controller } from '@hotwired/stimulus';

/**
 * Label picker - a <details> list of label chips (radios) whose summary shows the chosen label's chip. A pick copies
 * its chip into the summary; a click on a label also closes the list (arrow keys keep it open), as do Escape and a
 * click outside. A page refresh (morph) can leave no radio checked (or swap this controller for a new one), so
 * connect and turbo:morph restore the last chosen label, else the one checked in the HTML.
 * Targets: current - the chip in the summary
 * @example
 * <details data-controller="label-picker" data-action="click@window->label-picker#dismiss keydown.esc->label-picker#close turbo:morph@window->label-picker#restore">
 *   <summary><span class="label-chip label-chip--blue" data-label-picker-target="current">Design</span></summary>
 *   <label data-action="click->label-picker#choose"><input type="radio" name="label_id" data-action="change->label-picker#pick"><span class="label-chip …">…</span></label>
 * </details>
 */
export default class extends Controller {
  static targets = ['current'];

  connect () {
    this.restore();
  }

  pick (event) {
    this.value = event.target.value;
    this.show(event.target);
  }

  // Pointer clicks only (detail > 0): the radio's own click, from the label or the keyboard, has none.
  choose (event) {
    if (event.detail > 0) this.element.open = false;
  }

  dismiss (event) {
    if (!this.element.contains(event.target)) this.element.open = false;
  }

  close () {
    if (!this.element.open) return;

    this.element.open = false;
    this.element.querySelector('summary').focus();
  }

  restore () {
    const radios = [...this.element.querySelectorAll('input[type="radio"]')];
    const radio = radios.find((input) => input.value === this.value) || radios.find((input) => input.checked) ||
      radios.find((input) => input.defaultChecked) || radios[0];
    if (!radio) return;

    radio.checked = true;
    this.show(radio);
  }

  show (radio) {
    const chip = radio.closest('label').querySelector('.label-chip');
    this.currentTarget.className = chip.className;
    this.currentTarget.textContent = chip.textContent;
  }
}
